// This file was auto-generated by Fern from our API Definition.
export var AppScopeRequest;
(function (AppScopeRequest) {
    AppScopeRequest.Level = {
        Read: "read",
        ReadWrite: "read-write",
    };
})(AppScopeRequest || (AppScopeRequest = {}));
